module.exports = __webpack_public_path__ + "media/images/tin-e9f567fb094e9d82238db7ce943160df.jpg";